<template lang="pug">
  .pdp-sub-banner
    .container.xs-mt-150m.xs-pr-100m.xs-pl-100m
      .fixed-width-tweak-upper
        template(v-if='subscription.id')
          .row.md-hide.lg-hide.xs-mb-100m
            PdpExistingSubscription.xs-12

        .row.xs-mb-50m
          .back-to-advisor.xs-f-xsmall.max-at-tweak.xs-6.sm-6.md-2.lg-2
            a.underline.upper.bold(v-if='quizUrl' :href="quizUrl") {{ quizLinkText }}

          .md-8.lg-8.xs-hide.sm-hide.text-center.xs-mb-100m
            PdpExistingSubscription(v-if='subscription.id')

          .more-colors.xs-f-xsmall.max-at-tweak.xs-6.sm-6.md-2.lg-2.text-right
            a.underline.upper.bold(v-if='moreColorsUrl' :href="moreColorsUrl") More Colors

</template>

<script>
import { mapState } from "vuex";
import PdpExistingSubscription from "./PdpExistingSubscription/PdpExistingSubscription";

export default {
  name: "PdpExistingSubBanner",
  components: {PdpExistingSubscription},
  props: {
    quizCompleted: {
      type: Boolean,
      required: false
    },

    quizUrl: {
      type: String,
      required: false
    },

    moreColorsUrl: {
      type: String,
      required: false
    }
  },

  computed: {
    ...mapState('pdp', ['subscription']),

    quizLinkText() {
      return this.quizCompleted ? 'Edit Quiz' : 'Find My Perfect Shade';
    }
  }
}
</script>

<style scoped lang="stylus">
  .pdp-sub-banner
    border-bottom 1px solid ui-color-5

</style>